<template>
  <div class="container-fluid">
    <div class="heightcontainer">
      <landing-navbar></landing-navbar>
        <section class="section1 mt-2 pb-5 pt-5">
            <img src="../../assets/UpdatedLanding6.png" class="bgimg" alt="bg">
          <div class="container-fluid pt-5 pb-3 pb-md-0 pb-lg-5 d-md-flex containerfluidcontent">
            <div class="col-md-6 my-auto">
              <h1 class="font48-bold-main proximanova-bold mt-5">Hire candidates that bring value to your company</h1>                     
              <p class="fontsize20 mt-3 mb-1 proximanova pointerIcon">Big ideas. Amazing talent. The recruiting software that brings them together.</p>            
              <div class="pb-3 mt-4 pb-5">
                <button class="btn p-2 mt-3 pl-4 pr-4 fontsize16 borderradius20 mouseoverbtn2 backgroundcolor3 proximanova-semibold white" @click="NavToUserSignUp">Get Started</button>
              </div>
              <span class="d-none d-lg-block">
              <div class="d-flex flex-column mt-md-5">
                <span class="fontsize16 proximanova-semibold black60">Supported by 3k+ companies</span>
                <div class="d-flex flex-wrap mt-4 col-10 p-0 justify-content-between">
                    <img src="../../assets/UpdatedLandingcomLogo1.png" width="100px" class="mt-2" alt="company1">
                    <img src="../../assets/UpdatedLandingcomLogo5.png" width="100px" class="mt-2 ml-3" alt="company1">
                    <img src="../../assets/UpdatedLandingcomLogo3.png" width="100px" class="mt-2 ml-3" alt="company1">
                    <img src="../../assets/UpdatedLandingcomLogo4.png" width="100px" class=" mt-2  ml-3" alt="company1">
                </div>
              </div>
              </span>
            </div>
            <div class=" bordernone borderradius20 my-lg-auto col-md-6 mx-auto pl-0 pr-0 mt-4 mt-md-5 mt-lg-4">
              <div class="col-lg-11 mx-auto">
                <img src="../../assets/UpdatedLanding1.png" class="img-fluid mt-4 mt-md-0" alt="career">
              </div>
            </div>
          </div>
          <span class="d-block d-lg-none">
            <div class="d-flex flex-column mt-3 p-3">
              <span class="fontsize16 proximanova-semibold black60">Supported by 3k+ companies</span>
                <div class="d-flex flex-wrap justify-content-around mt-2">
                    <img src="../../assets/UpdatedLandingcomLogo1.png" height="35px" class="col-5 col-md-3 mt-3" alt="company1">
                    <img src="../../assets/UpdatedLandingcomLogo5.png" height="35px" class="col-5 col-md-3 mt-3" alt="company1">
                    <img src="../../assets/UpdatedLandingcomLogo3.png" height="35px" class="col-5 col-md-3 mt-3" alt="company1">
                    <img src="../../assets/UpdatedLandingcomLogo4.png" height="35px" class="col-5 col-md-3 mt-3" alt="company1">
                </div>
              </div>
          </span>
        </section>
        <section class="container-fluid d-md-flex pt-md-5 pt-lg-0 pb-5 backgroundcolorwhite">
            <div class="d-none d-md-block col-md-6 col-lg-5 my-auto pl-0">
                <img src="../../assets/UpdatedLanding2.png" class="img-fluid" alt="">
            </div>
            <div class="col-md-6 col-lg-7 my-auto p-lg-5">
                <div class="d-flex p-lg-4 flex-column ml-lg-5">
                    <div class="col-lg-10 d-flex flex-column mt-lg-3">
                        <span class="fontsize32 proximanova-bold black mt-3">Send Job details to exactly <span class="blue">suitable candidates </span>with One Click</span>
                        <span class="fontsize16 proximanova black mt-2 mt-lg-4">Explore thousands of video resumes and profiles and select candidates that match your brand voice perfectly. Personalize your experience that helps to take better decisions.</span>
                    </div>
                </div>
            </div>
            <div class="d-block d-md-none col-md-6 col-lg-5 mt-2">
                <img src="../../assets/UpdatedLanding2.png" class="img-fluid" alt="">
            </div>
        </section>  
        <section class="container-fluid d-md-flex pt-md-5 pb-5 backgroundcolorwhite">
            <div class="col-md-6 col-lg-7 my-auto p-lg-5">
                <div class="d-flex p-lg-4 flex-column ml-lg-5">
                    <div class="col-lg-10 d-flex flex-column mt-lg-3">
                        <span class="fontsize32 proximanova-bold black mt-3">Use platform recommendations to match with the best Candidates</span>
                        <span class="fontsize16 proximanova black mt-2 mt-lg-4">Worknotion's inbuilt recruitment software will help you instantly find candidates who fit the role after posting a job. You will have many suitable candidate profiles that speak of proper skills, education and experience.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-5 my-auto pr-3 pr-md-0">
                <img src="../../assets/UpdatedLanding3.png" class="img-fluid mt-4 mt-md-0" alt="">
            </div>
        </section> 
        <section class="container-fluid d-md-flex pt-md-5 pt-lg-0 pb-5 backgroundcolorwhite">
            <div class="d-none d-md-block col-md-6 col-lg-5 my-auto pl-0">
                <img src="../../assets/UpdatedLanding4.png" class="img-fluid" alt="">
            </div>
            <div class="col-md-6 col-lg-7 my-auto p-lg-5">
                <div class="d-flex p-lg-4 flex-column ml-lg-5">
                    <div class="col-lg-10 d-flex flex-column mt-lg-3">
                        <span class="fontsize32 proximanova-bold black mt-3">Pick from a range of verified candidate profiles.</span>
                        <span class="fontsize16 proximanova black mt-2 mt-lg-4">All the candidate profiles you will see and explore on our platform are 100% verified through the Worknotion verification protocol, which is mandatory for any professional registered on our platform.</span>
                    </div>
                </div>
            </div>
            <div class="d-block d-md-none col-md-6 col-lg-5 mt-2">
                <img src="../../assets/UpdatedLanding4.png" class="img-fluid" alt="">
            </div>
        </section>  
        <section class="container-fluid d-md-flex pt-md-5 pb-5 backgroundcolorwhite">
            <div class="col-md-6 col-lg-7 my-auto p-lg-5">
                <div class="d-flex p-lg-4 flex-column ml-lg-5">
                    <div class="col-lg-10 d-flex flex-column mt-lg-3">
                        <span class="fontsize32 proximanova-bold black mt-3">Shortlist candidates through a straightforward approach</span>
                        <span class="fontsize16 proximanova black mt-2 mt-lg-4">Selecting candidates for an interview has never been so quick and easy. Determine which candidates have passed the job role requirements through ATS, showing a list of qualified candidates that make going towards the interview process more manageable.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-5 my-auto pr-3 pr-md-0">
                <img src="../../assets/UpdatedLanding5.png" class="img-fluid mt-4 mt-md-0" alt="">
            </div>
        </section>
        <section class="container-fluid d-md-flex pt-md-5 pt-lg-0 pb-5 backgroundcolorwhite">
            <div class="d-none d-md-block col-md-6 col-lg-5 my-auto pl-0">
                <img src="../../assets/UpdatedLanding7.png" class="img-fluid" alt="">
            </div>
            <div class="col-md-6 col-lg-7 my-auto p-lg-5">
                <div class="d-flex p-lg-4 flex-column ml-lg-5">
                    <div class="col-lg-10 d-flex flex-column mt-lg-3">
                        <span class="fontsize32 proximanova-bold black mt-3">Hire with Ease</span>
                        <span class="fontsize16 proximanova black mt-2 mt-lg-4">Take video interviews of candidates after they have matched all your criteria related to educational qualifications, skills and experience. Finally, hire the ones that promise value to your company vision.</span>
                    </div>
                </div>
            </div>
            <div class="d-block d-md-none col-md-6 col-lg-5 mt-2">
                <img src="../../assets/UpdatedLanding7.png" class="img-fluid" alt="">
            </div>
        </section>
        <section class="section3 backgroundcolor3 pt-5 pb-5 pl-3 pr-3 pl-md-5 pr-md-5 pr-lg-0">
          <div class="container-fluid pt-5 pb-5 d-md-flex containerfluidcontent">
            <div class="col-lg-12">
              <div class="vertical-center text-center pl-md-3 pr-md-3">   
                <h2 class="font48-bold-main white proximanova-bold">Ready for the big change?</h2>
                <h2 class="font48-bold-main white proximanova-bold"> Let’s connect!</h2>                       
              </div>
              <div class="pb-3 pl-md-3 pr-md-3 mt-4 text-center">
                <button class="btn fontsize18 signupbtnstyles p-2 mt-3 pl-5 pr-5 borderradius20 newbtnstyles backgroundcolorblack proximanova-semibold white" @click="NavToSignup">Sign Up</button>
              </div>
            </div>
          </div>
        </section> 
    </div>    
    <Footer class="footer" ></Footer>
  </div> 
</template>
<script>
import BottomFooter from "@/components/BottomFooter.vue";
import Footer from '../footer.vue'
import router from '../../router.js'
import LandingNavbar from './Navbar.vue'
import wndata from '../../js/wn_data.json'
import $ from 'jquery'
export default {
  components: {
    BottomFooter,   
    Footer,
    LandingNavbar
  },
  data() {
    return {
    };
  },
  methods: {
    NavToSignup() {
      router.push({
        name : 'signup'
      })
    },
    NavToUserSignUp() {
      router.push({
        name : 'signup'
      })
    }
  },
  mounted: function() {
    window.scrollTo(0, 0)
  },
  computed: {
    
  }
};
</script>
<style scoped>
.bgimg{
    position: absolute;
    z-index: 1;
    margin-right: -4%;
    margin-top: -15%;
    top: 0;
    right: 0;
}
.section1{
    position: relative;
    z-index: 2;
    overflow: hidden;
}
.containerfluidcontent{
    position: relative;
    z-index: 2;
}
.button-create{
  font-size: 14px !important;
}
.button-create:focus {
  outline: 0 !important;
}
.signupbtnstyles{
  width: 300px;
  height: 75px;
  font-size: 24px;
  border-radius: 40px !important;
  z-index: 3;
}
.videocard{
  background: black;
  border-radius: 20px;
  padding: 25px 0;
}
#videoTag{
  width: 100%;
  /* background-image: linear-gradient(rgba(31, 31, 31, .1), rgba(31,31,31,.1)), url(''); */
}
.landingElementStyles{
  width: 150px;
  position: absolute;
  margin-top: -90px;
  z-index: 1;
}
.zindex1{
  z-index: 1 !important;
}
.zindex2{
  z-index: 2 !important;
}
.gradientColor1{
  /* background: -webkit-linear-gradient(rgb(27, 140, 233), rgb(147, 209, 209), rgb(2, 61, 61)) !important;
  -webkit-background-clip: text !important; */
  -webkit-text-fill-color: transparent !important;
  background: -webkit-linear-gradient(left, yellow , red);
   background: -o-linear-gradient(right, yellow , red);
   background: -moz-linear-gradient(right, yellow , red);
   background: linear-gradient(to right, yellow , red); 
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.gradientColor2{
  background: -webkit-linear-gradient(#12c2e9, #c471ed, #f7797d) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}
.gradientColor3{
  background: -webkit-linear-gradient(rgb(182, 44, 20), rgb(209, 203, 147), rgb(63, 175, 12)) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}
#playvideobtn{
  margin-top: 60px !important;
}
.pausebtn{
  display: none;
  margin-top: 60px !important;
  margin-left: 44% !important;
}
.videocard:hover .pausebtn{
  display: block;
  margin-top: 75px !important;
}
.section2bacgImg{
  z-index: 1;
  position: absolute;
  margin-top: 30%;
  left: 0;
  margin-left: 40px !important;
}
.section2frontimg{
  z-index: 2;
  position: relative;
}
.section7bacgImg{
  z-index: 1;
  position: absolute;
  left: 0;
  margin-left: 10px !important;
}
.newbtnstyles {
	transition : ease-out 0.3s;
	  POSITION : relative;
	  z-index : 1;
  }
  .newbtnstyles::before{
	transition : 0.5s all ease;
	  position : absolute;
	  top : 0;
	  left : 30%;
	  right : 30%;
	  bottom : 0;
	  opacity : 0;
	  content : "";
	border-radius: 40px;
	margin-top: 0px;
	  background-color :  rgba(255, 255, 255, .35);
  }
  .newbtnstyles:hover::before{
	transition : 0.5s all ease;
	  left : 0;
	  right : 0;
	  opacity : 1;
	  z-index : -1
  }
@media (min-width: 992px){
  .containerfluidcontent{
    width: 90% !important;
  }
  .whatpeoplesayCard{
    position: absolute;
    z-index: 2;
    margin-top: 8%;
  }
  #videoTag{
    height: 460px !important;
  }
  #playvideobtn{
    margin-top: 200px !important;
  }
  .pausebtn{
    display: none;
    margin-top: 220px !important;
    margin-left: 48% !important;
  }
  .videocard:hover .pausebtn{
    display: block;
    margin-top: 215px !important;
  }
}
section {
 margin: 0 0 0rem 0rem  !important ;
}
.footer {
  background-color: black;       
  color : white;
  position: sticky;
}
.top-padding{
  padding-top:3rem !important;
}
h2{
  font-weight: 300;
}
.section1 {
  background-color:white;
}
.section2 {
  background-color:white;
}   
@media screen and (min-width: 300px) and (max-width: 350px) {
  .top-padding{
    padding-top:0rem !important;
  }
  .font24-reg-main{
    font-size: 16px;
  }
  .font48-bold-main {	
    font-size: 24px;	
  }
  .font40-bold-main{
    font-size: 20px;
  }
}
@media screen and (min-width: 350px) and (max-width: 400px) {
  .top-padding{
    padding-top:0rem !important;
  }
  .font24-reg-main{
    font-size: 16px;
  }
  .font48-bold-main {	
    font-size: 24px;	
  }
  .font40-bold-main{
    font-size: 20px;
  }
}
@media screen and (min-width: 300px) and (max-width: 600px) {
  .section1content{
    margin-top: 12% !important;
  }
  .top-padding{
    padding-top:0rem !important;
  }
  .signupbtnstyles{
    width: 200px;
    height: 50px;
    font-size: 20px;
    border-radius: 40px !important;
  }
}
@media screen and (min-width: 600px) and (max-width: 800px) {
  .section1content{
    margin-top: 12% !important;
  }
  #playvideobtn{
    margin-top: 160px !important;
  }
  .pausebtn{
    display: none;
    margin-top: 160px !important;
    margin-left: 46% !important;
  }
  .videocard:hover .pausebtn{
    display: block;
    margin-top: 175px !important;
  }
  .signupbtnstyles{
    width: 200px;
    height: 50px;
    font-size: 20px;
    border-radius: 40px !important;
  }
}
@media screen and (min-width: 400px) and (max-width: 600px) {
  .top-padding{
    padding-top:0rem !important;
  }
  .font48-bold-main {	
    font-size: 28px;	
  }
  .font40-bold-main{
    font-size: 24px;
  }
  .font24-reg-main {
    font-size: 18px;
  }
  .bgimg{
    width: 100%;
        position: absolute;
        z-index: 1;
        margin-right: 0%;
        margin-top: 95%;
        top: 0;
        right: 0;
    }
}
@media screen and (max-width: 900px) and (min-width: 800px) {
  .top-padding{
    padding-top:0rem !important;
  }
}
@media screen and (max-width: 700px) and (min-width: 600px) {
  .top-padding{
    padding-top:0rem !important;
  }
}
@media screen and (max-width: 800px) and (min-width: 700px) {
  .top-padding{
    padding-top:0rem !important;
  }
}
@media screen and (max-width: 800px) and (min-width: 600px) {
    .bgimg{
    width: 100%;
        position: absolute;
        z-index: 1;
        margin-right: -30%;
        top: 0;
        right: 0;
    }
}
</style>
